<!-- @format -->

<div
	class="badge"
	*ngIf="badge.type !== 'none'"
	[style.background-color]="badge.backgroundColor"
	[style.color]="badge.foregroundColor">
	<span>{{ badge.type }}</span>
</div>
